export const FEATURE_FLAGS = {
  /** Enable new CDN-based hospitality menu browser with sharding + virtual scroll */
  HOSPITALITY_MENU_V2: process.env.REACT_APP_HOSPITALITY_MENU_V2 === '1',

  /** Enable Service Worker */
  SERVICE_WORKER: process.env.REACT_APP_SERVICE_WORKER === '1',
};
